import axios from "axios";

// Backend URL configuration
const API_BASE = "http://localhost:8082";            // Backend base URL
const USER_API = `${API_BASE}/api/seo-user`;         // Signup API
const AUTH_API = `${API_BASE}/authenticate`;         // Login API

// ------------------- LOGIN -------------------
export const login = async (dto) => {
  try {
    const response = await axios.post('http://localhost:8082/authenticate', dto, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    
    // Store token if returned
    if (response.data.jwtToken) {
  localStorage.setItem('token', response.data.jwtToken);
}

    
    return response.data;
  } catch (error) {
    console.error('Login failed:', error.response?.data || error.message);
    throw error;
  }
};
// ------------------- SIGNUP -------------------
export const signup = async (formData) => {
  try {
    const signupPayload = {
      actionType: "INSERT",
      name: formData.name,
      email: formData.email,
      password: formData.password,
      mobile: formData.mobile
    };

    const response = await axios.post(USER_API, signupPayload, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (err) {
    console.error("Signup API error:", err.response ? err.response.data : err);
    return null;
  }
};
